var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#E94057"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.904 20.2H29.496C23.672 20.2 20.2 23.672 20.2 29.496V42.904C20.2 48.728 23.672 52.2 29.496 52.2H42.904C48.728 52.2 52.2 48.728 52.2 42.904V29.496C52.2 23.672 48.728 20.2 42.904 20.2ZM32.952 40.84L29.352 44.44C29.112 44.68 28.808 44.792 28.504 44.792C28.2 44.792 27.88 44.68 27.656 44.44L26.456 43.24C25.976 42.776 25.976 42.008 26.456 41.544C26.92 41.08 27.672 41.08 28.152 41.544L28.504 41.896L31.256 39.144C31.72 38.68 32.472 38.68 32.952 39.144C33.416 39.608 33.416 40.376 32.952 40.84ZM32.952 29.64L29.352 33.24C29.112 33.48 28.808 33.592 28.504 33.592C28.2 33.592 27.88 33.48 27.656 33.24L26.456 32.04C25.976 31.576 25.976 30.808 26.456 30.344C26.92 29.88 27.672 29.88 28.152 30.344L28.504 30.696L31.256 27.944C31.72 27.48 32.472 27.48 32.952 27.944C33.416 28.408 33.416 29.176 32.952 29.64ZM45.096 43.592H36.696C36.04 43.592 35.496 43.048 35.496 42.392C35.496 41.736 36.04 41.192 36.696 41.192H45.096C45.768 41.192 46.296 41.736 46.296 42.392C46.296 43.048 45.768 43.592 45.096 43.592ZM45.096 32.392H36.696C36.04 32.392 35.496 31.848 35.496 31.192C35.496 30.536 36.04 29.992 36.696 29.992H45.096C45.768 29.992 46.296 30.536 46.296 31.192C46.296 31.848 45.768 32.392 45.096 32.392Z",
    fill: "url(#paint0_linear_13_2538)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_2538",
    x1: -10.5368,
    y1: 55.2638,
    x2: 66.1398,
    y2: 25.3848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A2387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E94057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgService);
export default __webpack_public_path__ + "static/media/img-service.7dfc617fb39f2cf89e8cb1345fdb70b5.svg";
export { ForwardRef as ReactComponent };